import type { CPU } from '../CPU';

export function opSWI(cpu: CPU): void {
  cpu.raiseException(1, cpu.impl_operands[0].value);
}

export function opBRK(cpu: CPU): void {
  cpu.raiseException(1, 0);
}
